<!-- Non-modal: it must not trap the page, since nothing loads while the choice is
     pending and there is no reason to hold someone hostage to it. -->
<div #panel class="consent-banner" role="dialog" aria-modal="false" tabindex="-1"
  aria-labelledby="consent-heading">
  <!-- No .center here any more: the card itself is capped at 600px, so the text
       is bounded by the box rather than by a second width limit inside it. -->
  <div class="consent-banner-inner stack" style="--stack-gap: var(--space-s)">
    <h2 id="consent-heading" class="consent-heading" i18n="@@consent.heading">Vi värdesätter din integritet</h2>
    <!-- The claims are only what we actually do: the site works, and with consent
         we analyse usage and measure advertising. Nothing else is promised. -->
    <p class="consent-body" i18n="@@consent.body">Vi använder cookies för att sajten ska fungera och, med ditt samtycke, för att analysera hur den används och för marknadsföring. Genom att klicka på ”Acceptera alla” samtycker du till vår användning av cookies.</p>

    @if (showSettings()) {
    <div class="consent-categories stack" style="--stack-gap: var(--space-xs)">
      <h3 class="consent-settings-heading" i18n="@@consent.settingsHeading">Hantera samtycke</h3>

      <div class="consent-category">
        <mat-checkbox [checked]="true" [disabled]="true">
          <span i18n="@@consent.category.necessary">Nödvändiga</span>
          <span class="consent-always-on" i18n="@@consent.category.necessary.always">Alltid aktiva</span>
        </mat-checkbox>
        <p class="consent-category-description" i18n="@@consent.category.necessary.description">Krävs för att sajten ska fungera. Kan inte stängas av.</p>
      </div>

      <div class="consent-category">
        <mat-checkbox [checked]="analyticsChoice()"
          (change)="analyticsChoice.set($event.checked)">
          <span i18n="@@consent.category.analytics">Analys</span>
        </mat-checkbox>
        <p class="consent-category-description" i18n="@@consent.category.analytics.description">Hjälper oss förstå hur sajten används. Avstängd tills du godkänner.</p>
      </div>

      <div class="consent-category">
        <mat-checkbox [checked]="marketingChoice()"
          (change)="marketingChoice.set($event.checked)">
          <span i18n="@@consent.category.marketing">Marknadsföring</span>
        </mat-checkbox>
        <p class="consent-category-description" i18n="@@consent.category.marketing.description">Låter oss och våra annonspartner mäta effekten av annonser. Avstängd tills du godkänner.</p>
      </div>
    </div>
    }

    <!-- One row of three, accept last so it sits on the right. Reject precedes it
         in the DOM, so the keyboard reaches reject first, and both are one click
         from first paint. All three share .consent-button, so only the fill
         differs; nothing here may make rejecting the longer path. -->
    <div class="consent-actions">
      @if (showSettings()) {
      <button mat-stroked-button type="button" class="consent-button consent-save"
        (click)="saveSelection()" i18n="@@consent.save">Spara val</button>
      } @else {
      <button mat-stroked-button type="button" class="consent-button consent-settings-link"
        (click)="openSettings()" i18n="@@consent.settings">Anpassa</button>
      }
      <button mat-stroked-button type="button" class="consent-button" (click)="rejectAll()"
        i18n="@@consent.rejectAll">Avvisa</button>
      <button mat-flat-button color="primary" type="button" class="consent-button"
        (click)="acceptAll()" i18n="@@consent.acceptAll">Acceptera alla</button>
    </div>
  </div>
</div>
